export enum AppRoute {
  Home = "",
  LoyaltyProgram = "loyaltyProgram",
  Widget = "widget"
}
